import styled, { css } from 'styled-components';

export const Container = styled.div`
    width: 260px;
    height: 100vh;
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    background-color: #102A63;
    color: #FFFFFF;
    box-shadow: 4px 0 20px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    
    &.show, &.hide{
        transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        -webkit-transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }

    &.hide{
        transform: translateX(-100%);
    }

    &.show{
        transform: translateX(0);
    }

    .li-logo{
        padding: 7px 10px;
        width: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        
        img{
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: auto;
            object-fit: contain;
        }
    }
`;

export const SidebarHeader = styled.div`
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    height: 70px;
    display: flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.02);
    backdrop-filter: blur(10px);
    padding: 0;

    .close-button{
        padding: 24px;
        width: 70px;
        border-right: 1px solid rgba(255, 255, 255, 0.1);
        text-align: center;
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background-color 0.2s ease;

        svg{
            opacity: 0.7;
            cursor: pointer;
            transition: all 0.2s ease;
            color: #FFFFFF;

            &:hover{
                opacity: 1;
                transform: scale(1.1);
                color: #00b1eb;
            }
        }

        &:hover{
            background-color: rgba(255, 255, 255, 0.05);
        }
    }

    .li-logo{
        padding: 7px 10px;
        width: calc(100% - 70px);
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        
        img{
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: auto;
            object-fit: contain;
        }
    }
`;

export const SidebarBody = styled.div`
    padding-left: 0;
    padding-top: 0;
    overflow-y: auto;
    overflow-x: hidden;
    height: 92%;

    ul{
        list-style-type: none;
        padding: 0;
        margin: 0;

        &.submenu{
            margin-left: 0;
            padding-left: 0;
            padding-top: 0;
            padding-bottom: 0;
            overflow: hidden;
            max-height: 0;
            opacity: 0;
            transform: translateY(-8px);
            transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1),
                        opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1),
                        transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
            
            &.open{
                max-height: 1000px;
                opacity: 1;
                transform: translateY(0);
            }
        }
    }

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 10px;
        transition: background 0.2s ease;

        &:hover{
            background: rgba(255, 255, 255, 0.3);
        }
    }
`;

export const MenuItem = styled.li`
    width: 100%;
    height: 45px;
    cursor: pointer;
    padding: 9px 0px 9px 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    transition: all 0.2s ease;
    border-bottom: 1px solid #BDC7DA25;

    &:hover{
        background-color: #fff;
    }

    ${props => props.$isActive && css`
        &::before{
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 60%;
            background: linear-gradient(180deg, #00b1eb 0%, #0099cc 100%);
            border-radius: 0 3px 3px 0;
        }
    `}
`;

export const ActiveIndicator = styled.div`
    position: absolute;
    left: ${props => props.$isSubItem ? '15px' : '0'};
    top: 0;
    bottom: 0;
    width: 3px;
    background: linear-gradient(180deg, #00b1eb 0%, #0099cc 100%);
    border-radius: 0 3px 3px 0;
    animation: slideIn 0.2s ease-out;
    
    @keyframes slideIn {
        from {
            width: 0;
        }
        to {
            width: 3px;
        }
    }
`;

export const ChevronIcon = styled.span`
    position: absolute;
    left: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), color 0.2s ease;
    color: ${props => props.$isOpen ? '#00b1eb' : 'rgba(255, 255, 255, 0.6)'};
    transform: ${props => props.$isOpen ? 'rotate(90deg)' : 'rotate(0deg)'};
    
    ${MenuItem}:hover & {
        color: #102A63;
    }
`;

export const SubMenuItem = styled.li`
    width: 100%;
    height: 45px;
    cursor: pointer;
    padding: 9px 0px 9px 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    transition: background-color 0.2s ease, transform 0.2s ease;
    border-bottom: 1px solid #BDC7DA25;
    opacity: 0;
    transform: translateX(-8px);
    
    .submenu.open & {
        animation: slideInItem 0.35s cubic-bezier(0.4, 0, 0.2, 1) forwards;
        animation-delay: ${props => (props.$index || 0) * 0.05}s;
    }

    @keyframes slideInItem {
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }

    &:hover{
        background-color: #fff;
        transform: translateX(2px);
    }
    
    .submenu.open &:hover {
        transform: translateX(2px);
    }
`;

export const MenuItemLabel = styled.label`
    cursor: pointer;
    display: flex;
    margin: ${props => props.$isSubItem ? '0' : '0 0 0 30px'};
    padding: 0;
    text-decoration: none;
    text-align: left;
    font-size: 14px;
    line-height: 1.5;
    letter-spacing: 0px;
    color: ${props => props.$isActive ? '#FFFFFF' : '#BDC7DA'};
    font-weight: ${props => props.$isActive ? '600' : '400'};
    width: 100%;
    transition: all 0.2s ease;
    user-select: none;
    opacity: 1;
    
    ${MenuItem}:hover &, ${SubMenuItem}:hover & {
        color: #102A63;
        font-weight: bold;
    }
`;

export const SidebarFooter = styled.div`
    padding: 20px 30px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
`